import { tw } from '@/lib/utils'

interface VsMarkProps {
  /** The (already translated) "vs" text; trailing period stripped like the pair page hero. */
  label: string
  className?: string
}

// The pair page's merigold "vs" medallion at chip scale — the directory reuses
// it wherever two products are named as a matchup (popular comparisons, the
// compare tray). Purely visual; the screen-reader text is inline.
export const VsMark = ({ label, className }: VsMarkProps) => (
  <span
    className={tw(
      'bg-merigold text-navy inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[11px] leading-none italic',
      className
    )}
    style={{ fontFamily: 'var(--font-fraunces), Georgia, serif', fontWeight: 600 }}
  >
    <span aria-hidden className="-mt-px">
      {label.replace(/\.$/, '')}
    </span>
    <span className="sr-only"> {label} </span>
  </span>
)
